import { render } from "./GalleryThree.vue?vue&type=template&id=1f9b459d"
import script from "./GalleryThree.vue?vue&type=script&lang=js"
export * from "./GalleryThree.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__